import { useGetCurrentUser } from '@front/auth/src/authentication-context';

import { getIsInstantTaxCreditSelected } from '@front/common/src/ducks/customer/basket-selectors';
import { useAppSelector } from '@front/common/src/store/store';

export const useIsITCSelectedOrSuccessfullyPaired = () => {
  const user = useGetCurrentUser();
  const isInstantTaxCreditSelected = useAppSelector(getIsInstantTaxCreditSelected);
  const isWecasaCarePairingSuccessful = user?.wecasa_care_pairing_status === 'successful';
  const isITCSelectedOrSuccessfullyPaired = isWecasaCarePairingSuccessful || isInstantTaxCreditSelected;
  return {
    isInstantTaxCreditSelected,
    isITCSelectedOrSuccessfullyPaired: isITCSelectedOrSuccessfullyPaired ?? false,
    isWecasaCarePairingSuccessful,
  };
};
